module.exports = __webpack_public_path__ + "static/sbm-e629fa32fca67f7421284ce9c00fc6e7.png";